<ng-container *ngIf="info">
    <nz-avatar
        [ngStyle]="{'background-color': bgColor}"
        [nzSrc]="info.avatar ? avatarImage : null"
        [nzText]="!info.avatar ? (label | capitalize) : null"
        [nzSize]="size"
        [nz-tooltip]="showTooltip?label:null"
        [ngClass]="{'inactive-member': !enable}"
        ></nz-avatar>
</ng-container>
